import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20 max-w-6xl" }
const _hoisted_3 = {
  key: 1,
  class: "text-gray-500"
}

import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import DynamicReport from '@/components/reports/DynamicReport.vue'
import ReportDownloadHistory from '@/components/reports/ReportDownloadHistory.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { reportDetailByPath } from '@/config/reportGroups'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'


export default {
  __name: 'ReportDetailPage',
  setup(__props) {

const route = useRoute()
const reportDateRangeByPath = ref({})
const canReadReports = computed(() => privilegeService.canAccessResourceAction('reports', null, 'read'))
const config = computed(() => reportDetailByPath[route.path] ?? null)
const initialSelectedIds = computed(() => {
  const codeId = route.query.code_id
  if (codeId) {
    const num = Number(codeId)
    return Number.isFinite(num) && num > 0 ? [num] : []
  }
  return []
})
const isPayoutSummary = computed(() => route.path === '/payout-summary')

const reportDownloadHistoryTypeFilter = computed(() => config.value?.downloadReportType ?? null)
const showReportDownloadHistory = computed(() => reportDownloadHistoryTypeFilter.value !== null)
const reportDownloadHistorySimplifiedType = computed(() =>
  isPayoutSummary.value ? undefined : reportDownloadHistoryTypeFilter.value ?? undefined
)

const reportDateRange = computed(() => reportDateRangeByPath.value[route.path] ?? null)

function onReportDateRange(range) {
  reportDateRangeByPath.value = { ...reportDateRangeByPath.value, [route.path]: range }
}

watch(
  config,
  report => {
    if (report?.downloadReportType && canReadReports.value) {
      api.call('GET', 'data_downloads')
    }
  },
  { immediate: true }
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      (config.value)
        ? (_openBlock(), _createBlock(SecondaryTop, {
            key: 0,
            text: config.value.title
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (canReadReports.value && config.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(DynamicReport, {
                  "report-id": config.value.reportId,
                  title: config.value.title,
                  description: config.value.description,
                  "date-filter": config.value.dateFilter,
                  "min-date": config.value.minDate,
                  "max-date": config.value.maxDate,
                  "dropdown-filter": config.value.dropdownFilter,
                  "dropdown-options": config.value.dropdownOptions || [],
                  "has-supporting-table": config.value.hasSupportingTable,
                  "data-source": config.value.dataSource,
                  "chart-type": config.value.chartType,
                  "dropdown-filter2": config.value.dropdownFilter2,
                  "dropdown2-label": config.value.dropdown2Label,
                  "dropdown-filter3": config.value.dropdownFilter3,
                  "dropdown3-label": config.value.dropdown3Label,
                  "initial-max-products": config.value.initialMaxProducts,
                  "initial-selected-ids": initialSelectedIds.value,
                  onReportDateRange: onReportDateRange
                }, null, 8, ["report-id", "title", "description", "date-filter", "min-date", "max-date", "dropdown-filter", "dropdown-options", "has-supporting-table", "data-source", "chart-type", "dropdown-filter2", "dropdown2-label", "dropdown-filter3", "dropdown3-label", "initial-max-products", "initial-selected-ids"]),
                (showReportDownloadHistory.value)
                  ? (_openBlock(), _createBlock(ReportDownloadHistory, {
                      key: 0,
                      "report-type-filter": reportDownloadHistoryTypeFilter.value,
                      "button-label": "Download report",
                      "simplified-for-payouts": isPayoutSummary.value,
                      "date-range": reportDateRange.value,
                      "simplified-report-type": reportDownloadHistorySimplifiedType.value
                    }, null, 8, ["report-type-filter", "simplified-for-payouts", "date-range", "simplified-report-type"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (!config.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Report not found."))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

}